import { render, staticRenderFns } from "./AreaRegionCreateForm.vue?vue&type=template&id=69cffcb0&"
import script from "./AreaRegionCreateForm.vue?vue&type=script&lang=js&"
export * from "./AreaRegionCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports